<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M5.13039 9.26043L3.10622 7.23626C2.87872 7.00876 2.51122 7.00876 2.28372 7.23626C2.05622 7.46376 2.05622 7.83126 2.28372 8.05876L4.72206 10.4971C4.94956 10.7246 5.31706 10.7246 5.54456 10.4971L11.7162 4.32543C11.9437 4.09793 11.9437 3.73043 11.7162 3.50293C11.4887 3.27543 11.1212 3.27543 10.8937 3.50293L5.13039 9.26043Z"
      fill="white"
    />
  </svg>
</template>
